import React                   from 'react'
import _utils2 from '../util/form-utils'
import _validationRules2 from '../util/validationRules'
import i18n from '../i18n';
import {defaultPerPage} from '../constants';
import {multiFilters, orderBy} from '../util/list-helper'

export default function withBaseComponent(superclass) {
  return class extends superclass {
    constructor(props) {
      super(props);

      // for paging
      this.paging =React.createRef()
      this.handlePagingChange = this.handlePagingChange.bind(this)

      // for modal
      this.toggleModal = this.toggleModal.bind(this)
      this.disableButton = this.disableButton.bind(this)
      this.enableButton = this.enableButton.bind(this)


      this.showErrors = this.showErrors.bind(this)

      this.state = {
        hasError: true,
        canSubmit: false,
        isOpenModal: false,
        loading: false,

        // for paging
        currentList: [],
        perPage: defaultPerPage.value,
        activePage: 1,
        totalCount: 0
      }
    }

    filters(list, filters) {
      list = [...list]

      return orderBy(
        multiFilters(list || [], filters || {}),
        this.state.orders || {attr: 'id', direction: 'asc'}
      )
    }

    handlePagingChange(name='list', activePage, perPage) {
      perPage = perPage || this.state.perPage
      activePage = activePage || this.state.activePage

      const filterList = this.filters(this.props[name], this.state.filters)
      const offset = (activePage - 1) * perPage
      const currentList = filterList.filter((a, i) => i >= offset && i < (offset + perPage))

      this.setState({
        perPage: perPage,
        activePage: activePage,
        totalCount: filterList.length,
        currentList: currentList
      })
    }

    componentDidCatch(error, info) {
      console.log(error, info)
    }

    componentWillReceiveProps(nextProps) {
      // handling 422 error from API response
      if(this.refs.form && this.refs.form.state.formSubmitted) {
        const error = nextProps.globalErrors
        if(error && error.status && error.status === 422) {
          this.setErrors(error.data.errors)
          this.props.globalActions.setGlobalFailure(null)
        }
      }
    }

    disableButton() {
      this.setState({ canSubmit: false });
    }

    enableButton() {
      this.setState({ canSubmit: true });
    }

    setFormError(isError) {
      this.setState({hasError: isError})
    }

    getCurrentValues() {
      const isServiceField = this.isServiceField
      return this.refs.form.inputs.reduce(function (data, component) {
        if (!isServiceField(component))
          return {}

        let dataCopy = Object.assign({}, data); // avoid param reassignment
        const keys = Object.keys(component.state.value)
        const key = keys.find(item => item !== "service_form_type")
        dataCopy[component.props.name] = component.state.value[key]
        return dataCopy;
      }, {})
    }

    validationRule(key) {
      let rule = {}
      switch (key) {
        case "alphameric":
        case "password":
          rule = {isNotEmpty: _validationRules2.isNotEmpty}
          break;
        // case "checkbox":
        //   rule = {isChecked: _validationRules2.isChecked}
        //   break;
        case "table":
          rule = {isTable: _validationRules2.isTable}
          break;
        default:
          break;
      }

      return rule
    }

    validationError(key, name = "この") {
      let message = ""
      switch (key) {
        case "isAlphanumeric":
          message = "This value is must alphameric"
          break;
        default:
          message = i18n.t('validations.serviceForms.required', {name: name})
          break;
      }

      return message
    }

    isServiceField(component) {
      return component !== null
             && component.state
             && typeof component.state.value === 'object'
             && component.state.value !== null
    }

    runValidation(component) {
      if (!this.isServiceField(component))
        return

      const keys = Object.keys(component.state.value)
      const key = keys.find(item => item !== "service_form_type")

      const value = component.state.value[key]
      const currentValues = this.getCurrentValues()
      let validateRules = this.validationRule(key)
      const validationResults = _utils2.runRules(value, currentValues, validateRules, validateRules)
      const isValid = validationResults && validationResults.failed.length === 0
      const isRequired = component.props.required

      const error = validationResults.failed.map(item => this.validationError(item, component.props.item.name))
      component.setState({
        isRequired: isRequired,
        isValid: isValid,
        error: error
      })

      let errors = {}
      if (!isValid)
        errors[component.props.name] = error[0]

      return errors
    }

    validateBetweenDate(model) {
      const fromDate = model["from_date"] ? new Date(model["from_date"]) : null
      const toDate = model["to_date"] ? new Date(model["to_date"]) : new Date()

      if (!model || !fromDate)
        return {}

      if (fromDate > toDate)
        return {to_date: i18n.t('validations.csv.betweenDate')}

      const ago3Months = toDate ? toDate.setMonth(toDate.getMonth() - 3) : null;
      if (ago3Months > fromDate.getTime())
        return {from_date: i18n.t('validations.csv.no3MonthsAgo')}

      return {}
    }

    resetFromDateError() {
      this.refs.form.inputs.forEach(input => {
        const validationErrors = input.props.validationErrors
        const hasError = validationErrors && Object.keys(validationErrors).length > 0
        if (input.props.name === "from_date" && !hasError) {
          var args = [{
            isValid: true,
            externalError: null
          }];
          input.setState.apply(input, args)
        }
      })
    };

    showErrors(data, invalidateForm) {
      if (!this.refs.form) {
        return
      }

      let errs = this.validateBetweenDate(this.refs.form.getCurrentValues())
      this.refs.form.inputs.forEach(input => {
        if (this.isServiceField(input) && input.isRequired()) {
          errs = Object.assign({}, errs, this.runValidation(input))
        } else {
          setTimeout(() => {
            if(input.isRequired() && ["", undefined, null].includes(input.state.value)) {
              let message = i18n.t('common.validation.required')
              if (input.props.defaultMessage === false)
                message = input.props.validationError
              errs[input.props.name] = message
            }
          })
        }
      })

      setTimeout(() => {
        this.setErrors(errs)
      }, this.refs.form.inputs.length * 50)

      return Object.keys(errs).length !== 0 || !this.refs.form.state.isValid
    }

    setErrors(errs) {
      this.refs.form && this.refs.form.state.formSubmitted && this.refs.form.updateInputsWithError(errs)
    }

    toggleModal(currentModal = null) {
      let isOpenModal = typeof(currentModal) === 'string'  ? true : !this.state.isOpenModal

      this.setState({isOpenModal: isOpenModal, currentModal: currentModal})
    }

    hasError() {
      return this.showErrors()
    }
  }
}
